/* istanbul ignore file */
import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogActions,
  DialogContent,
} from '@material-ui/core';
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from '@material-ui/pickers';
import { get, isEmpty } from 'lodash';
import { DATE_FORMAT } from 'constants/global';
import moment from 'moment-timezone';
import frLocale from 'date-fns/locale/fr';
import { isNil, uniqueId } from 'lodash';
import { IntlShape, injectIntl } from 'react-intl';
import styled from 'styled-components';
import { FormControl, InputLabel, Select, MenuItem } from '@material-ui/core';
import { translate } from 'containers/services/translate';
import messages from 'containers/RecapPage/messages';
import { COLORS } from 'constants/design';
import PrimaryButton from 'components/Buttons/PrimaryButton';
import SecondaryButton from 'components/Buttons/SecondaryButton';
import DateFnsUtils from '@date-io/date-fns';
import { dateStringToLocalDate } from 'containers/IdentificationPage/utils';
import { STAKE_HOLDERS_TYPES } from 'containers/CourtManagerLegalProceedings/Provision/constants';
import { HOLDER_PV_OTHER } from 'containers/RecapPage/canstants';

const StyledDiv = styled.div`
  width: 576px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  .select {
    width: 90%;
    margin-bottom: 33px;
    font-size: 13px;
  }
  .input {
    width: 90%;
    margin-bottom: 33px;
    font-size: 13px;
  }
`;
const StyledDialogActions = styled(DialogActions)`
  display: flex;
  padding: 20px 30px;
  justify-content: space-between;

  .moveButton {
    border: 1px solid ${COLORS.YELLOW};
    background-color: ${COLORS.YELLOW};
    color: ${COLORS.LIMED_SPURCE};
    &:hover {
      background-color: ${COLORS.YELLOW};
    }
  }

  .Mui-disabled {
    opacity: 0.6;
  }
`;

export interface AddFeeNoteDialogProps {
  intl: IntlShape;
  open: boolean;
  onClose: Function;
  lossDate: Date;
  listings: any;
  riskId: any;
  claimId: number;
  claimNumber: string;
  setUpdateCurrentRisk: Function;
  uploadedDocument: any;
  resetUploadDocumentStore: Function;
  uploadDocument: Function;
  setProvider: Function;
  provider: any;
  providerType: any;
  setProviderType: Function;
  setCompletionDate: Function;
  completionDate: any;
  setReceptionDate: Function;
  receptionDate: any;
  setOpenInvoiceFeeNoteInfoDialog: Function;
}

const AddFeeNoteDialog: React.FC<AddFeeNoteDialogProps> = (
  props,
): JSX.Element => {
  const [isInputChanged, setIsInputChanged] = useState<boolean>(true);
  const [
    isInputChangedDateCompletion,
    setIsInputChangedDateCompletion,
  ] = useState<boolean>(true);

  const { onClose, open } = props;
  const inputLabel = React.useRef<HTMLLabelElement>(null);

  const handleChange = (
    event: React.ChangeEvent<{
      value: unknown;
      name?: string;
    }>,
  ) => {
    const { value } = event.target;
    props.setProvider(value as any);
  };

  const handleClose = () => {
    onClose();
  };
  const handleChangeDate = (fieldName: string) => (date: any) => {
    if (fieldName === 'COMPLETION_DATE') {
      setIsInputChangedDateCompletion(!isInputChangedDateCompletion);
      props.setCompletionDate(date);
    } else {
      setIsInputChanged(!isInputChanged);
      props.setReceptionDate(date);
    }
  };

  const handleChangeType = (
    event: React.ChangeEvent<{
      value: unknown;
      name?: string;
    }>,
  ) => {
    const { value } = event.target;
    props.setProviderType(value);
    props.setCompletionDate(null);
    props.setReceptionDate(null);
  };

  return (
    <Dialog
      onClose={handleClose}
      aria-labelledby="simple-dialog-title"
      open={open}
    >
      <DialogTitle id="simple-dialog-title">
        {translate(messages.addFeeNote, props)}
      </DialogTitle>
      <DialogContent>
        <StyledDiv>
          <FormControl className="select">
            <InputLabel ref={inputLabel} id="demo-simple-select-outlined-label">
              {translate(messages.type, props)}
            </InputLabel>
            <Select
              value={props.providerType}
              onChange={handleChangeType}
              labelWidth={60}
            >
              {!isEmpty(get(props.listings, 'pvHolderType', [])) &&
                get(props.listings, 'pvHolderType', [])
                  .filter((el: any) => el.id != HOLDER_PV_OTHER)
                  .map((val: any) => (
                    <MenuItem key={uniqueId('stackholder_')} value={val.id}>
                      {val.title}
                    </MenuItem>
                  ))}
            </Select>
          </FormControl>
          {!isNil(props.providerType) && (
            <>
              <FormControl className="select">
                <InputLabel
                  ref={inputLabel}
                  id="demo-simple-select-outlined-label"
                >
                  {translate(
                    { ...messages.preOpeningManagerProviderDialogInput },
                    props,
                  )}
                </InputLabel>
                <Select
                  value={props.provider}
                  onChange={handleChange}
                  labelWidth={60}
                >
                  {get(props.listings, 'intervenants', [])
                    .filter(
                      (el: any) =>
                        el.ItemType ===
                        (props.providerType === 1
                          ? STAKE_HOLDERS_TYPES.IDENTIFIER
                          : STAKE_HOLDERS_TYPES.LAWYER),
                    )
                    .map((val: any) => (
                      <MenuItem
                        key={uniqueId('stackholder_')}
                        value={val.ItemKey}
                      >
                        {val.ItemDescription}
                      </MenuItem>
                    ))}
                </Select>
              </FormControl>

              <MuiPickersUtilsProvider utils={DateFnsUtils} locale={frLocale}>
                <KeyboardDatePicker
                  autoOk
                  disableFuture
                  variant="inline"
                  minDate={props.lossDate}
                  invalidDateMessage=""
                  format="dd/MM/yyyy"
                  id="completionDate"
                  onChange={handleChangeDate('COMPLETION_DATE')}
                  name={'COMPLETION_DATE'}
                  value={dateStringToLocalDate(props.completionDate as any)}
                  label={translate({ ...messages.dateCompletion }, props)}
                  className="input"
                  InputLabelProps={{
                    shrink: !!props.completionDate,
                    classes: { root: 'label-input' },
                  }}
                  error={
                    moment(new Date(props.completionDate)).format(DATE_FORMAT) <
                      moment(new Date(props.lossDate)).format(DATE_FORMAT) ||
                    new Date(props.completionDate) > new Date() ||
                    props.completionDate === ('' as any) ||
                    props.completionDate === null ||
                    moment(props.completionDate).format(DATE_FORMAT) ===
                      'Invalid date' ||
                    props.completionDate === ('Invalid Date' as any)
                  }
                  helperText={
                    moment(new Date(props.completionDate)).format(DATE_FORMAT) <
                      moment(new Date(props.lossDate)).format(DATE_FORMAT) ||
                    new Date(props.completionDate) > new Date() ||
                    props.completionDate === ('' as any) ||
                    props.completionDate === null ||
                    moment(props.completionDate).format(DATE_FORMAT) ===
                      'Invalid date' ||
                    props.completionDate === ('Invalid Date' as any)
                      ? translate(messages.dateCompletionError, props)
                      : ''
                  }
                />
              </MuiPickersUtilsProvider>

              <MuiPickersUtilsProvider utils={DateFnsUtils} locale={frLocale}>
                <KeyboardDatePicker
                  autoOk
                  disableFuture
                  variant="inline"
                  invalidDateMessage=""
                  format="dd/MM/yyyy"
                  minDate={props.completionDate}
                  id="receptionDate"
                  onChange={handleChangeDate('RECEPTION_DATE')}
                  name={'RECEPTION_DATE'}
                  value={dateStringToLocalDate(props.receptionDate as any)}
                  label={translate({ ...messages.dateReception }, props)}
                  className="input"
                  InputLabelProps={{
                    shrink: !!props.receptionDate,
                    classes: { root: 'label-input' },
                  }}
                  error={
                    moment(new Date(props.receptionDate)).format(DATE_FORMAT) <
                      moment(new Date(props.completionDate)).format(
                        DATE_FORMAT,
                      ) ||
                    new Date(props.receptionDate) > new Date() ||
                    props.receptionDate === ('' as any) ||
                    props.receptionDate === null ||
                    moment(props.receptionDate).format(DATE_FORMAT) ===
                      'Invalid date' ||
                    props.receptionDate === ('Invalid Date' as any)
                  }
                  helperText={
                    moment(new Date(props.receptionDate)).format(DATE_FORMAT) <
                      moment(new Date(props.completionDate)).format(
                        DATE_FORMAT,
                      ) ||
                    new Date(props.receptionDate) > new Date() ||
                    props.receptionDate === ('' as any) ||
                    props.receptionDate === null ||
                    moment(props.receptionDate).format(DATE_FORMAT) ===
                      'Invalid date' ||
                    props.receptionDate === ('Invalid Date' as any)
                      ? translate(messages.dateReceptionError, props)
                      : ''
                  }
                />
              </MuiPickersUtilsProvider>
            </>
          )}
        </StyledDiv>
      </DialogContent>
      <StyledDialogActions>
        <SecondaryButton
          onClick={handleClose}
          disableElevation
          title={translate(
            { ...messages.preOpeningManagerProviderDialogCancelButton },
            props,
          )}
        />
        <PrimaryButton
          onClick={() => {
            props.setOpenInvoiceFeeNoteInfoDialog(true);
            handleClose();
          }}
          disableElevation
          disabled={
            (!isNil(props.provider) &&
              (moment(new Date(props.receptionDate)).format(DATE_FORMAT) <
                moment(new Date(props.completionDate)).format(DATE_FORMAT) ||
                new Date(props.receptionDate) > new Date() ||
                props.completionDate === ('' as any) ||
                moment(props.completionDate).format(DATE_FORMAT) ===
                  'Invalid date' ||
                new Date(props.completionDate) === null ||
                moment(new Date(props.completionDate)).format(DATE_FORMAT) <
                  moment(new Date(props.lossDate)).format(DATE_FORMAT) ||
                new Date(props.completionDate) > new Date() ||
                props.receptionDate === ('' as any) ||
                props.receptionDate === null ||
                moment(props.receptionDate).format(DATE_FORMAT) ===
                  'Invalid date' ||
                props.receptionDate === ('Invalid Date' as any))) ||
            isNil(props.provider)
          }
          title={translate(
            { ...messages.preOpeningManagerProviderDialogValidationButton },
            props,
          )}
        />
      </StyledDialogActions>
    </Dialog>
  );
};

AddFeeNoteDialog.defaultProps = {
  open: false,
};

export default injectIntl(AddFeeNoteDialog);
